import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';
import {HttpEvent, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, mergeMap, tap} from 'rxjs/operators';
import {LocalStorageService} from 'angular-2-local-storage';
import {StorageItem} from '../enums/storage-item';
import {Profile} from '../domain/authentication/profile';

@Injectable()
export class TokenRenovationInterceptor {

  constructor(private router: Router,
              private authenticationService: AuthenticationService,
              private localStorage: LocalStorageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const response = next.handle(req);
    if (req.url.indexOf('/authorizations') < 0 && req.url.indexOf('/authorizations/accesstoken') < 0) {
      return response.pipe(
        tap(
          res => {
          }),
        catchError(
          error => {
            if (error.status === 401) {
              const profile: Profile = this.localStorage.get(StorageItem.PROFILE);
              return this.authenticationService.refreshToken().pipe(
                mergeMap(
                  response2 => {
                    const resp: any = response2;
                    profile.accessToken = resp.access_token;
                    profile.duration = resp.expires_in;
                    profile.tokenDate = new Date();
                    this.localStorage.set(StorageItem.PROFILE, profile);
                    const newRequest = req.clone({});
                    return next.handle(newRequest).pipe(
                      catchError(
                        error => {
                          error.status = 418; // TODO Mientras se corrige el manejo de excepciones, este error se maneja como 418 para poder distinguirlo en el common component.
                          return throwError(error);
                        }
                      ));
                  }),
              );
            } else {
              return throwError(error);
            }
          })
      );
    } else {
      return response;
    }
  }
}
